import React from 'react';
import './Form.css';

const Textarea = ({ label, error, ...props }) => {
    return (
        <div className="form-group">
            {label && <label className="form-label">{label}</label>}
            <textarea className={`form-textarea ${error ? 'form-input-error' : ''}`} {...props} />
            {error && <span className="form-error">{error}</span>}
        </div>
    );
};

export default Textarea;

